import React from 'react';
import { connect } from 'react-redux';
import {
  getUserAddressess,
  saveUserAddress,
  deleteUserAddress,
} from '../../api/api';
import { get, uniqueId, find, isEmpty } from 'lodash';
import { getUserId, getTokenId, getJWT } from '../../redux/reducers/authenticationReducers';
import { injectIntl } from 'react-intl';
import UserAddressFields from './UserAddressFields';
import { ToastContainer, ToastMessage } from '../../lib';
import { addressToString, getAlertifyHeader } from '../../lib/helper';
import { FormattedMessage } from 'react-intl';
import { ServerErrors } from '../../util/Errors';
import defaultMsg from '../../translations/lang/en-US.json';
import { MdLoaderTheme } from '../common/Loading';

let alertify = require('alertifyjs');

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

class ListUserAddress extends React.Component {
  getInitialState() {
    return {
      addressList: [],
      loading: true,
      error: false,
      activeAddress: {},
      save: false,
      updating: false,
    };
  }

  constructor(props) {
    super(props);
    this.state = this.getInitialState();

    this.editAddress = this.editAddress.bind(this);
    this.saveAddress = this.saveAddress.bind(this);
    this.renderAddress = this.renderAddress.bind(this);
    this.addAddress = this.addAddress.bind(this);
    this.cancel = this.cancel.bind(this);
    this.sendPrimaryDataToParent = this.sendPrimaryDataToParent.bind(this);
    this.deleteAddress = this.deleteAddress.bind(this);
  }

  componentDidMount() {
    getUserAddressess(this.props).then(response => {
      const result = get(response, 'data.DataResponse', []);
      if (result.status !== 'success') {
        this.setState({
          loading: false,
          error: this.props.intl.formatMessage({
            id: 'somethingWentWrong',
            defaultMessage: defaultMsg.somethingWentWrong,
          }),
        });
      } else {
        this.sendPrimaryDataToParent(result.data);
        this.setState({
          addressList: result.data,
          loading: false,
          error: false,
        });
      }
    });
  }

  sendPrimaryDataToParent(data) {
    if (this.props.recievePrimaryAddress) {
      this.props.recievePrimaryAddress(
        find(data, address => Number(address.is_primary) === 1)
      );
    }
  }
  cancel() {
    this.setState({
      activeAddress: {},
      save: false,
    });
  }

  addAddress() {
    this.setState({
      save: true,
      activeAddress: {},
    });
  }

  editAddress(data, isEnabled) {
    this.setState({
      activeAddress: data,
      save: !isEnabled && typeof isEnabled !== 'undefined' ? false : true,
    });
  }

  deleteAddressConfirm = callback => {
    return success => {
      alertify
        .confirm(
          getAlertifyHeader(
            this.props.intl.formatMessage({
              id: 'deleteAddressConfirm',
              defaultMessage: defaultMsg.deleteAddressConfirm,
            }),
            false,
            'center'
          ),
          '',
          function() {
            callback('success');
          },
          function() {
            callback('failed');
          }
        )
        .set('labels', {
          ok: this.props.intl.formatMessage({
            id: 'yes',
            defaultMessage: defaultMsg.yes,
          }),
          cancel: this.props.intl.formatMessage({
            id: 'no',
            defaultMessage: defaultMsg.no,
          }),
        })
        .set('closable', false);
    };
  };

  deleteAddress(data) {
    const { id } = data;
    const params = Object.assign(
      {},
      { user_id: this.props.userId },
      { id },
      this.props
    );
    if (this.refs.listOfUsers) {
      this.refs.listOfUsers.style.opacity = '.5';
    }
    deleteUserAddress(params)
      .then(response => {
        const apiResponse = get(response, 'data.DataResponse', {});
        this.setState({ addressList: apiResponse.data });
        if (this.refs.listOfUsers) {
          this.refs.listOfUsers.style.opacity = '1';
        }
      })
      .catch(error => {});
  }
  saveAddress(data, makePrimary = false) {
    const params = Object.assign(
      {},
      data,
      { user_id: this.props.userId },
      this.props
    );
    if (this.state.addressList.length === 0) {
      params.is_primary = '1';
    }

    if (makePrimary === true) {
      params.is_primary = '1';
      if (this.refs.listOfUsers) {
        this.refs.listOfUsers.scrollTop = 0;
      }
    }
    if (params.addressName === '') {
      this.refs.alert.error(
        this.props.intl.formatMessage({
          id: 'errorAddressName',
          defaultMessage: defaultMsg.errorAddressName,
        })
      );
    } else {
      this.setState({
        updating: true,
      });
      if (this.refs.listOfUsers) {
        this.refs.listOfUsers.style.opacity = '.5';
      }
      saveUserAddress(params)
        .then(response => {
          const apiResponse = get(response, 'data.DataResponse', {});
          if (apiResponse.status === 'success') {
            this.sendPrimaryDataToParent(apiResponse.data);
            this.setState({
              addressList: apiResponse.data,
              activeAddress: {},
              save: false,
            });
            this.refs.alert.success(apiResponse.msg);
          } else {
            this.refs.alert.error(apiResponse.msg || ServerErrors[505]);
          }
          this.setState({
            updating: false,
          });
          if (this.refs.listOfUsers) {
            this.refs.listOfUsers.style.opacity = '1';
          }
        })
        .catch(error => {
          this.refs.alert.error(ServerErrors[505]);
          this.setState({
            updating: false,
          });
          if (this.refs.listOfUsers) {
            this.refs.listOfUsers.style.opacity = '1';
          }
        });
    }
  }

  renderAddress(data) {
    let editDelLink = { float: 'right' };
    let verticalBar = {
      color: 'black',
      font: 'icon',
    };
    if (
      (isEmpty(data['address_1']) &&
        data['address_1'] !== 'undefined undefined') ||
      isEmpty(data['address_2']) ||
      !isEmpty(data['address_2'])
    ) {
      return (
        <div key={uniqueId('address-key-' + data.id)} className="panel">
          <div className="panel-body">
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xs-6 col-sm-6">
                {data.name}
              </div>
              <div className="col-md-6 col-lg-6 col-xs-6 col-sm-6 text-right font-small">
                {data.is_primary === '1'
                  ? this.props.intl.formatMessage({
                      id: 'primary',
                      defaultMessage: defaultMsg.primary,
                    })
                  : ''}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12 col-lg-12 col-xs-12 col-sm-12">
                {addressToString(data)}
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                <div className="pull-right">
                  <button
                    type="button"
                    className="olo-client-theme-color btn-link"
                    onClick={() => this.editAddress(data)}
                  >
                    <FormattedMessage
                      id="editAddress"
                      defaultMessage={defaultMsg.editAddress}
                    />
                  </button>
                  {data.is_primary === '0' ? (
                    <div style={editDelLink}>
                      <span style={verticalBar}>|</span>
                      <button
                        type="button"
                        className="olo-client-theme-color btn-link"
                        onClick={() => this.saveAddress(data, true)}
                      >
                        <FormattedMessage
                          id="makePrimary"
                          defaultMessage={defaultMsg.makePrimary}
                        />
                      </button>
                    </div>
                  ) : (
                    ''
                  )}
                  <span style={verticalBar}>|</span>
                  <button
                    type="button"
                    className="olo-client-theme-color btn-link"
                    onClick={this.deleteAddressConfirm(deleteRes => {
                      if (deleteRes === 'success') {
                        this.deleteAddress(data);
                      }
                    })}
                  >
                    <FormattedMessage
                      id="deleteAddress"
                      defaultMessage={defaultMsg.deleteAddress}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="alert"
          className="toast-top-right"
        />
        <div className="user-address-list col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                  <div className="pull-left">
                    <h4>
                      <b>
                        <FormattedMessage
                          id="addressInformation"
                          defaultMessage={defaultMsg.addressInformation}
                        />
                      </b>
                    </h4>
                  </div>
                  {this.state.save !== true ? (
                    <div className="pull-right">
                      <button
                        type="button"
                        className="btn btn-success font-small olo-client-theme-color-white olo-client-theme-background "
                        onClick={this.addAddress}
                      >
                        <FormattedMessage
                          id="addAddress"
                          defaultMessage={defaultMsg.addAddress}
                        />
                      </button>
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 col-lg-12">
                  {this.state.updating === true ? (
                    <center>
                      <FormattedMessage
                        id="updatingList"
                        defaultMessage={defaultMsg.updatingList}
                      />
                    </center>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12 col-lg-6">
              {this.state.loading === true ? (
                <div>
                  <MdLoaderTheme size={30} />
                </div>
              ) : this.state.error !== false ? (
                <div>{this.state.error}</div>
              ) : this.state.addressList.length ? (
                <div ref="listOfUsers" className="list-user-address">
                  {this.state.addressList.map(data => this.renderAddress(data))}
                </div>
              ) : (
                <div className="empty-result-set">
                  <FormattedMessage
                    id="noResultsFound"
                    defaultMessage={defaultMsg.noResultsFound}
                  />
                </div>
              )}
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12 col-lg-6">
              <UserAddressFields
                onChange={(data, isEnabled) =>
                  this.editAddress(data, isEnabled)
                }
                formState={this.state.activeAddress}
                saveAddress={data => this.saveAddress(data)}
                save={this.state.save}
                cancel={this.cancel}
                optional={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tokenId: getTokenId(state),
  jwt: getJWT(state),
  userId: getUserId(state),
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ListUserAddress));



// WEBPACK FOOTER //
// ./src/views/myaccount/ListUserAddress.jsx